/*
 *
 * Package: `@dbh/air-slider-theme`.
 *
 */const THEME_KEY_AIR_SLIDER="airSlider";const modifyAirSliderTheme=a=>{let{spacing:{sp6:b},colors:{white:c}}=a;return {[THEME_KEY_AIR_SLIDER]:{borderRadius:"7px",horizontalSpacing:b,noBorderBottom:"false",slide:{backgroundColor:c,xsWidth:80,smWidth:38,mdWidth:28,lgWidth:25,xlWidth:25}}}};

export { THEME_KEY_AIR_SLIDER, modifyAirSliderTheme as default };
